exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.avatar.image {\n  margin: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainMusicTherapy/MainMusicTherapy.scss
// module id = 1283
// module chunks = 0